import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DownloadSimple, FileXls, FileCsv } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useT } from "@/contexts/I18nContext";

function triggerBrowserDownload(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

function parseFilename(cd, fallback) {
    if (!cd) return fallback;
    const m = /filename="?([^"]+)"?/i.exec(cd);
    return m ? m[1] : fallback;
}

export function ExportMenu({ endpoint, filters = {}, baseName = "export", testIdPrefix = "export" }) {
    const { t } = useT();
    const [busy, setBusy] = useState(false);

    const download = async (format) => {
        setBusy(true);
        try {
            const params = { format, ...filters };
            Object.keys(params).forEach((k) => {
                if (params[k] === "" || params[k] === null || params[k] === undefined) delete params[k];
            });
            const res = await api.get(endpoint, { params, responseType: "blob" });
            const ext = format === "csv" ? "csv" : "xlsx";
            const fallback = `${baseName}.${ext}`;
            const filename = parseFilename(res.headers?.["content-disposition"], fallback);
            triggerBrowserDownload(res.data, filename);
            toast.success(t("export_ok"));
        } catch (e) {
            toast.error(t("export_failed"));
        } finally {
            setBusy(false);
        }
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" disabled={busy} data-testid={`${testIdPrefix}-btn`}>
                    <DownloadSimple size={16} className="mr-2" />
                    {busy ? t("exporting") : t("export_label")}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem onClick={() => download("xlsx")} data-testid={`${testIdPrefix}-xlsx`}>
                    <FileXls size={16} className="mr-2" color="#1A3626" weight="fill" />
                    {t("export_xlsx")}
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => download("csv")} data-testid={`${testIdPrefix}-csv`}>
                    <FileCsv size={16} className="mr-2" color="#D99533" weight="fill" />
                    {t("export_csv")}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
